export let Account = {
    path: 'account',
    name: 'account',
    meta: {
        roleCode: '005',
    },
    component: () =>
        import(
            /* webpackChunkName: "account-page" */ '@/views/back-stage/account/account-page.vue'
        ),
    children: [
        {
            path: 'password',
            name: 'password',
            component: () =>
                import(
                    /*webpackChunkName:"change-password"*/ '@/views/back-stage/account/change-password.vue'
                ),
        },
        {
            path: 'info',
            name: 'info',
            component: () =>
                import(
                    /*webpackChunkName:"personal-info"*/ '@/views/back-stage/account/personal-info.vue'
                ),
        },
        {
            path: 'headimage',
            name: 'headimage',
            component: () =>
                import(
                    /*webpackChunkName:"head-image"*/ '@/views/back-stage/account/head-image.vue'
                ),
        },
        {
            path: 'signature',
            name: 'signature',
            component: () =>
                import(
                    /*webpackChunkName:"personal-signature"*/ '@/views/back-stage/account/personal-signature.vue'
                ),
        },
        {
            path: 'agent',
            name: 'agent',
            component: () =>
                import(
                    /*webpackChunkName:"agent-page"*/ '@/views/back-stage/account/agent-page.vue'
                ),
        },
        {
            path: 'equipment',
            name: 'equipment',
            component: () =>
                import(
                    /*webpackChunkName:"equipment-page"*/ '@/views/back-stage/account/equipment-page.vue'
                ),
        },
        {
            path: 'circulate',
            name: 'circulate',
            component: () =>
                import(
                    /*webpackChunkName:"circulate-list"*/ '@/views/back-stage/circulate-list/circulate-list.vue'
                ),
        },
        {
            path: '*',
            redirect: 'password',
        },
    ],
};
